module.exports = __webpack_public_path__ + "static/media/title.5bdc021a.png";